'use strict'

import EL from '../constant/elements'

/**
 * フォームバリデーションの処理
 */
export default () => {
  const func = {
    validateItems: document.querySelectorAll('.js-validate'),
    submitButton: document.querySelector('.js-submit'),

    /**
     * init
     */
    init: () => {
      func.validateItems.forEach(item => {
        item.addEventListener('change', func.formValidate, false)
      })
      if (func.submitButton) func.submitButton.addEventListener('click', func.formValidate, false)
    },

    /**
     * formValidate
     */
    formValidate: () => {
      func.validateItems.forEach(item => {
        if (!item.classList.contains('is-validated')) {
          item.classList.add('is-validated')
        }
      })
    },
  }

  func.init()
}
